import { Button } from "primereact/button";

const MarkingControlButton = ({ data, onClickRemove, disabled }) => {
  return (
    <div className="row-between-start w-full gap-1">
      <div className="row-start-start bg-green-100 w-full min-h-[2.8rem] px-2 md:px-4 py-2 rounded-md">
        <span className="text-sm md:text-base text-slate-700 shrink-0 w-[2rem] md:w-[2.5rem] text-left ">
          # {data.urutan}
        </span>
        <span className="text-sm md:text-base leading-tight md:leading-snug !font-semibold text-slate-700 min-w-0 break-words">
          {data.keterangan}
        </span>
      </div>
      {!disabled && (
        <Button
          className="max-h-[24rem] shrink-0 bg-red-400 border-red-400"
          icon="pi pi-times"
          onClick={() => {
            if (onClickRemove) onClickRemove(data);
          }}
        />
      )}
    </div>
  );
};

export default MarkingControlButton;
